import { useFetch } from "@common/hooks/useFetch";
import { useContext, useEffect, useState } from "react";
import { NumberOfferContext } from "../App";
import { ICart } from "@features/cart/ICart";
import { getProspectId } from "@utils/storage";
import { getCartRoute,getCartCrossSellRoute } from "@api-routes";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useGetCart = (callback?: (cart: ICart | undefined) => void) => {
    const [userCart, setUserCart] = useState<ICart | undefined>();
    const [userCartState, { get }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const getCart = () => {
        const prospectId = getProspectId();

        if (prospectId) {
            get<ICartResponse>(keycloakUtils.isAuthenticated()?getCartCrossSellRoute():getCartRoute(), {
                isSecured: keycloakUtils.isAuthenticated(),
                headers: {
                    "Cache-Control": "no-cache",
                },
            }).then((cartResponse) => {
                if (cartResponse) {
                    const cart = getResponseToState(cartResponse);

                    setNumberOfferSelected(cart.offers.length);
                    setUserCart(cart);

                    if (callback) {
                        callback(cart);
                    }
                } else if (callback) {
                    callback(undefined);
                }
            });
        } else if (callback) {
            callback(undefined);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getCart, []);

    return { userCart, setUserCart, userCartState, getCart };
};
